import { render, staticRenderFns } from "./CreateEditNode.vue?vue&type=template&id=2dcc0bfa&"
import script from "./CreateEditNode.vue?vue&type=script&lang=js&"
export * from "./CreateEditNode.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditNode.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcc0bfa')) {
      api.createRecord('2dcc0bfa', component.options)
    } else {
      api.reload('2dcc0bfa', component.options)
    }
    module.hot.accept("./CreateEditNode.vue?vue&type=template&id=2dcc0bfa&", function () {
      api.rerender('2dcc0bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Story/Modals/CreateEditNode.vue"
export default component.exports